// 这份文件就是用来做拦截的
 
import axios from 'axios'

 
// 创建一个单例（实例）
const instance = axios.create({
    // baseURL:'http://www.sitemerge.com',
    // baseURL:'https://ceshi.liuyanniangzhi.com',
    baseURL:'https://unified.liuyanniangzhi.com/',
    
    // timeout: 4000
})

let i=0
// 拦截器 - 请求拦截
instance.interceptors.request.use(config=>{
    // 临时禁用。。。。。。。。。。。。
    // window.fullscreenLoadingF()
    i++
    // 部分接口需要拿到token
    let token = localStorage.getItem('userToken');
    if(token){
        config.headers['Authorization'] = `Bearer ${token}`
    }
    return config;
}, err=>{
    return Promise.reject(err)
});
 
 
// 拦截器 - 响应拦截
instance.interceptors.response.use(res=>{
    i--
    if(i==0){
         // 临时禁用。。。。。。。。。。。。
        // window.fullscreenLoading.close()
    }
    return res;
}, err=>{
    return Promise.reject(err)
});
 
// 整体导出
export default instance;


// WEBPACK FOOTER //
// ./src/request/request.js